module.exports = __webpack_public_path__ + "static/img/liveacc-theme.4e0125e.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/registerflow-new/liveacc-theme.svg
// module id = CGYD
// module chunks = 4